export class StateModel {
    loading = false;
    isMounted = false;
}
